import { Icon } from '@wartek-id/icon'
import { Input, InputGroup, InputLeftAddon } from '@wartek-id/input'
import { Text } from '@wartek-id/text'

import { cn } from '@/utils/styling'

export function WilayahSearchText({ onChange, className = '' }) {
  return (
    <div className={cn('p-4', className)}>
      <Text variant="heading-sm">Pilih wilayah</Text>
      <div className="mt-4">
        <InputGroup>
          <InputLeftAddon>
            <Icon>search</Icon>
          </InputLeftAddon>
          <Input
            size="sm"
            placeholder={`Cari wilayah provinsi, kota, atau kabupaten`}
            name="keyword-wilayah"
            onChange={onChange}
            data-testid="txt-keyword-wilayah"
          />
        </InputGroup>
      </div>
    </div>
  )
}
